<template>
  <div class="nav" v-if="show3">
    <el-container>
      <el-header>
        <div class="container">
          <div class="it-nav">
            <div class="item-meun">
              <img src="../assets/introduce/imageIco.png" />
              <span
                :class="[active == 1 ? 'item_active' : 'item_home']"
                @click="pathHome"
                >首页</span
              >
              <span
                @click="pathFunction"
                :class="[active == 2 ? 'item-model-active' : 'item-model']"
                >功能/定价</span
              >
              <span
                :class="[active == 3 ? 'item-course-active' : 'item-course']"
                @click="pathCourse"
                >优质课程</span
              >
            </div>
            <div class="item-login" v-show="show1">
              <span class="login" @click="loginNew">登录</span>
              <span class="freeUse" @click="loginNew">免费使用</span>
            </div>
            <div class="item-login" v-show="show2">
              <span class="login" @click="pathCollege">我的书院</span>
              <div class="head_image">
                <el-avatar :size="40" :src="this.headPic"></el-avatar>
              </div>
              <span class="login">{{ phoneNum }}</span>
              <span class="loginout" @click="logout">退出</span>
            </div>
          </div>
        </div>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import { myorg, userAuthQuery } from "@/api/Apis.js";
import { setCookie, getCookie, removeCookie } from "@/utils/cookies";
import { baseinfo } from "@/api/Apis.js";
export default {
  data() {
    return {
      show1: true,
      show2: false,
      headPic: "",
      phoneNum: "",
      show3: true,
      active: 0
    };
  },
  created() {
    var token = getCookie("myToken");
    if (token == "" || token == null) {
      console.log("未登录");
    } else {
      this.show1 = false;
      this.show2 = true;
      this.show3 = false;
      this.UserDatainfo();
      this.handleUserHasOrg();
    }
  },
  mounted() {
    this.watchPath();
    if (!getCookie("num")) {
      setCookie("num", 0);
    }
  },
  watch: {
    $route(to, from) {
      if (to.path === "/introduceHome") {
        this.active = 1;
      } else if (to.path == "/function") {
        this.active = 2;
      } else if (to.path == "/course") {
        this.active = 3;
      }
    }
  },
  methods: {
    watchPath() {
      if (
        this.$route.path == "/introduceHome" ||
        this.$route.path == "/introduceHome/"
      ) {
        this.active = 1;
      } else if (
        this.$route.path == "/function" ||
        this.$route.path == "/function/"
      ) {
        this.active = 2;
      } else if (
        this.$route.path == "/course" ||
        this.$route.path == "/course/"
      ) {
        this.active = 3;
      }
    },
    handleUserHasOrg() {
      this.isHasRedirect();
      this.handleUserAuthority();
      myorg({
        current: 1,
        size: 100
      }).then(res => {
        if (res.msg == "success") {
          var hasOrg = res.data.total > 0;
          setCookie("hasOrg", hasOrg); //是否有机构
          let realAuth = JSON.parse(getCookie("realNameAuth"));
          let redirect = JSON.parse(getCookie("redirect"));
          if (redirect) return this.$router.push(redirect);
          let path;
          if (hasOrg == false) {
            path = "/introduceHome"; // 跳到介绍页页面
            this.show3 = true;
            this.$message.warning("您当前未加入任何一个书院");
          } else if (hasOrg == true && realAuth == true) {
            // path = "/index";
            path = this.$route.path;
            if (getCookie("num") == 0) {
              path = "/index";
              setCookie("num", 1);
            }
            this.show3 = true;
          } else if (hasOrg == true && realAuth == false) {
            path = "/Userauth";
          }
          this.$router.push({
            path: path
          });
        }
      });
    },
    handleUserAuthority() {
      userAuthQuery({}).then(res => {
        if (res.msg == "success") {
          setCookie("realNameAuth", res.data.realNameAuth); //是否实名认证
        }
      });
    },
    isHasRedirect() {
      let redirect = this.$route.query.redirect; //是目标拦截的情况，记录redirect
      if (redirect != undefined) {
        setCookie("redirect", redirect);
      } //判断从何处路由进入
      if (redirect) return this.$router.push(redirect);
    },
    pathHome() {
      this.$router.push("/introduceHome");
    },
    pathFunction() {
      this.$router.push("/function");
    },
    pathCourse() {
      this.$router.push("/course");
    },
    loginNew() {
      // https://login-center.i-ronge.com/#/login
      setCookie("redirectUrl", window.location.href);
      const Url = window.location.host;
      if (Url === "organ-test.i-ronge.com") {
        //测试网址
        window.location.href = "https://login-center-test.i-ronge.com/#/login";
      } else if (Url === "localhost:8080") {
        // 本地跳转
        window.location.href = "https://login-center-test.i-ronge.com/#/login";
      } else if (Url === "organ.i-ronge.com") {
        // 默认正式
        window.location.href = "https://login-center.i-ronge.com/#/login";
      } else if (Url === "business.i-ronge.com") {
        // 默认正式
        window.location.href = "https://login-center.i-ronge.com/#/login";
      }
    },
    pathCollege() {
      let hasOrg = JSON.parse(getCookie("hasOrg"));
      if (hasOrg == false) {
        this.$message.error("您还没有创建/加入任何书院");
        return false;
      }
      this.$router.push("/index");
    },
    //获取用户信息
    UserDatainfo() {
      baseinfo({}).then(res => {
        if (res.msg == "success") {
          this.headPic = res.data.headPic;
          this.phoneNum = res.data.hidePhone;
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    //退出
    logout() {
      removeCookie("myToken");
      removeCookie("hasOrg");
      removeCookie("realNameAuth");
      removeCookie("redirect");
      removeCookie("redirectUrl");
      removeCookie("Inputphone");
      removeCookie("num");
      this.$message({
        message: "退出登陆成功",
        type: "success"
      });
      setTimeout(function() {
        window.location.reload();
      }, 1000);
    }
  }
};
</script>
<style scoped>
.nav >>> .el-header {
  height: 60px !important;
  padding: 0;
  background-image: url("../assets/introduce/bg1.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.nav >>> .el-main {
  padding: 0;
}
.it-nav {
  display: flex;
  justify-content: space-between;
}
.item-meun {
  display: flex;
}
.item-meun img {
  display: block;
  width: 40px;
  height: 40px;
  margin-top: 16px;
}
.item_active {
  display: block;
  text-align: left;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  color: #ffffff;
  padding-bottom: 9px;
  border-bottom: 1px solid #fff;
  margin: 30px 35px 0 30px;
  cursor: pointer;
}
.item_home {
  display: block;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 400;
  text-align: left;
  color: #fefeff;
  margin: 30px 35px 0 30px;
  cursor: pointer;
}
.item-model {
  display: block;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 400;
  text-align: left;
  color: #fefeff;
  margin: 30px 35px 0 0;
  cursor: pointer;
}
.item-model-active {
  display: block;
  text-align: left;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  color: #ffffff;
  padding-bottom: 9px;
  border-bottom: 1px solid #fff;
  margin: 30px 35px 0 0;
  cursor: pointer;
}
.item-course {
  display: block;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 400;
  text-align: left;
  color: #fefeff;
  margin-top: 30px;
  cursor: pointer;
}
.item-course-active {
  display: block;
  text-align: left;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  color: #ffffff;
  padding-bottom: 9px;
  border-bottom: 1px solid #fff;
  margin-top: 30px;
  cursor: pointer;
}
.item-login {
  display: flex;
  margin-right: 50px;
}
.login {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #fefeff;
  display: block;
  margin: 30px 34px 0 0;
  cursor: pointer;
}
.freeUse {
  cursor: pointer;
  display: block;
  width: 90px;
  height: 30px;
  border: 1px solid #ffffff;
  background: #fff;
  border-radius: 10px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #1b6fd6;
  margin-top: 20px;
  line-height: 30px;
}
.head_image {
  width: 40px;
  height: 40px;
  margin: 20px 22px 0px 0px;
  cursor: pointer;
}
.loginout {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 400;
  text-align: left;
  color: #fefeff;
  display: block;
  margin-top: 30px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/nav.vue